import * as apiGetSettingKey from 'api/setting/GetSettingV1';
import * as apiGetUserSettingKey from 'api/userSetting/GetUserSettingKeyV1';
import { protectRoutes } from 'components/desktop/_general/ProtectedRoute/ProtectedRoute';
import Archive from 'containers/desktop/Menu/Archive/MenuArchive';
import Detail from 'containers/desktop/Menu/Detail/MenuDetail';
import New from 'containers/desktop/Menu/New/MenuNew';
import Search from 'containers/desktop/Menu/Search/MenuSearch';
import PERMISSIONS from 'enums/permissions';
import { isNotEmptyOrNull } from 'functions/stringsExtensions';
import { createMenuLoadedAction } from 'reducers/MenuReducer';
import * as Menu from 'types/Menu/Menu';
import { defaultSettingDto } from 'types/Setting/Setting';

const MenuPlanIdParamsName = 'menuPlanId';
const MenuPlanRowIndexParamsName = 'menuPlanRowIndex';
const MenuPlanDayParamsName = 'menuPlanDay';

const routes = [
	{
		path: '/menu/detail/:id',
		element: <Detail />,
		permissions: [PERMISSIONS.READMENU],
		resources: ['tagList', 'statusList'],
		loader: async ({ dispatch, getState }: any, _: any, params: any) => {
			// HACK: this code is duplicated from ProtectedRoutesContainer.getCurrencyToRedux
			// we need to call it twice since there is a race condition
			// can we make a new PBI to solve the race condition between the Loaders and the ProtectedRoutesContainer,
			// and keep this hack as an intermediate solution??
			const userCurrency = await apiGetUserSettingKey.callApi('Price.Currency');
			const currency = await userCurrency
				.filter((x) => isNotEmptyOrNull(x))
				.orElseAsync(async (): Promise<string> => {
					const settings = await apiGetSettingKey.callApi();
					return settings.getOrDefault(defaultSettingDto()).currencySettings
						.primaryCurrency;
				});

			const menu = await Menu.getFromApi(getState().menu, {
				...params,
				currencyCode: currency,
			});
			dispatch(createMenuLoadedAction(menu));

			return '';
		},
	},
	{
		path: '/menu/search',
		element: <Search />,
		permissions: [PERMISSIONS.READMENU],
	},
	{
		path: `/menu/search/menuPlan/:${MenuPlanIdParamsName}/:${MenuPlanRowIndexParamsName}/:${MenuPlanDayParamsName}`,
		element: <Search />,
		permissions: [PERMISSIONS.READMENU],
	},
	{
		path: '/menu/archive',
		element: <Archive />,
		permissions: [PERMISSIONS.WRITEMENU],
	},
	{
		path: '/menu/copy/:id',
		element: <Detail />,
		permissions: [PERMISSIONS.WRITEMENU],
		resources: ['tagList', 'statusList', 'menuCopy/:id'],
	},
	{
		path: '/menu/new',
		element: <New />,
		permissions: [PERMISSIONS.WRITEMENU],
		resources: ['tagList', 'statusList', 'menuNew'],
	},
];

export default protectRoutes(routes);
